import * as React from "react";
import {Video} from "@models/video-content";
import { Rate , Table, Button, Divider, Icon, Tooltip} from "antd";
import {FormattedMessage, intlShape} from "react-intl";
import './index.scss'
import {getFormattedPrice} from '@utils';
import __i18n from "@intl/__i18n";
import {PaymentTypeOptions} from "@models/paymentType";
import FormattedDateTime from "../../../custom/FormattedDateTime";
import {getFormattedDate} from "../../../../utils";


type Props = {
  data: Video[];
  loading: boolean;
  deleteFn: (item: Video) => void;
  intl: intlShape.isRequired;
  currentPage: number;
};

const ReportList: React.FC<Props> = props => {
  const {data, loading} = props;
  
  const columns = [
    {
      title: <FormattedMessage id="app.index" defaultMessage={`Index`}/>,
      width: 30,
      dataIndex: "id",
      key: "id",
      render: (a, b, i) => <span>{i + 1 }</span>
    },
    {
      title: __i18n("Total Amount"),
      dataIndex: "sum_amount",
      key: "sum_amount",
      align:"right",
      render: (sum_amount) => getFormattedPrice(sum_amount)
    },
    {
      title: <FormattedMessage id="app.total_count" defaultMessage={`Total Count`}/>,
      dataIndex: "total",
      key: "total",
      align:"left",
    }, {
      title: <FormattedMessage id="app.date" defaultMessage={`Date`}/>,
      dataIndex: 'date_time',
      key: 'date_time',
      align:"left",
      render: (date_time) => getFormattedDate({date : date_time, showTime: false})
    },
  ];
  
  return (
    <Table
      className={'report-table'}
      columns={columns}
      loading={loading}
      pagination={false}
      dataSource={data}
      rowKey="id"
    />
  );
};

export default ReportList;
